module.exports = __webpack_public_path__ + "media/images/bg_illustration-7b04b7ad3e334d728b9b849ad419ee10.svg";